module.exports = __webpack_public_path__ + "static/media/user_icon.6dae5483.svg";